import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { getFaqsListing, inactiveFaqs, deleteFaq } from "../../api/apiHandler";
import { convertUTCToLocal, showMessage, showErrorMessage } from "../common/Utils";
import $, { trim } from 'jquery';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";

export function Faqslisting() {

    const customStyles = {
        header: {
            style: {
                position: "sticky",
                top: 0,
                zIndex: 2,
                backgroundColor: "#f5f5f5", // Customize as needed
            },
        },
        headCells: {
            style: {
                backgroundColor: '#B6A878',
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'center',
                padding: '10px',
            },
        },
        cells: {
            style: {
                padding: '8px',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
            },
        },
    };

    const timezone = localStorage.getItem('timezone');

    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({ page: 1, perPage: 50 });
    const [sortField, setSortField] = useState("id");
    const [sortOrder, setSortOrder] = useState("DESC");
    const [showModal, setShowModal] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState({});

    // Fetch data from server
    const fetchData = async () => {
        setLoading(true);
        try {
            
            const faqReq = {
                page: pagination.page,
                per_page: pagination.perPage,
                search,
                sort: sortField,
                order: sortOrder,
            }
            const response = await getFaqsListing(faqReq);
            if (parseInt(response.code) === 1) {
                setData(response.data.items);
                setTotalRows(response.data.totalcount);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading FAQs, please try again later");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [pagination, search, sortField, sortOrder]);
    
    // Handle pagination
    const handlePageChange = (page) => {
        setPagination((prev) => ({ ...prev, page }));
    };
    
    const handlePerRowsChange = (perPage) => {
        setPagination({ page: 1, perPage });
    };
    
      // Handle sorting
    const handleSort = (column, sortDirection) => {
        setSortField(column.sortableField); // Field to sort by
        setSortOrder(sortDirection.toUpperCase()); // ASC or DESC
    };

    const handleOnChangeEvent = async (e) => {

        try {
            let status = e.target.dataset.status === '1' ? 0 : 1;
            let userId = e.target.dataset.userid;
            let txtStatus = e.target.dataset.status === '1' ? 'active' : 'inactive';

            // Show confirmation dialog
            const result = await Swal.fire({
                title: "",
                text: `Are you sure you want to ${txtStatus} this FAQ?`,
                imageUrl: process.env.PUBLIC_URL + '/logo.png',
                imageSize: '80x80',
                showCancelButton: true,
                confirmButtonColor: "#B6A878",
                cancelButtonColor: "#d33",
                confirmButtonText: e.target.dataset.status === '1' ? "Active" : "Inactive",
            });
            if (result.isConfirmed) {
                const updUsers = {
                    status: status,
                    faq_id: userId
                }
                const response = await inactiveFaqs(updUsers);
                if (parseInt(response.code) === 1) {
                    showMessage(response.message);
                    fetchData();
                } else {
                    showErrorMessage(response.message);
                }
            }
        } catch (error) {
            showErrorMessage("An unexpected error occurred inactivating/activating record!");
        }
    };

    const showDeleteConfirmation = async (faq_id) => {
        try {
            // Show confirmation dialog
            const result = await Swal.fire({
                title: "",
                text: "Are you sure you want to delete this FAQ? It can't be reverted back!",
                imageUrl: process.env.PUBLIC_URL + '/logo.png',
                imageSize: '80x80',
                showCancelButton: true,
                confirmButtonColor: "#B6A878",
                cancelButtonColor: "#d33",
                confirmButtonText: "Confirm",
            });
            
            if (result.isConfirmed) {

                const updUsers = {
                    is_deleted: true,
                    faq_id: faq_id
                }

                const response = await deleteFaq(updUsers);
                if (parseInt(response.code) === 1) {
                    showMessage(response.message);
                    fetchData();
                } else {
                    showErrorMessage(response.message);
                }
            }
        } catch (error) {
            showErrorMessage("An unexpected error occurred deleting record!");
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>FAQs Listing</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">FAQs Listing</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="table-responsive">
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div>
                                                <a href="/authpanel/faqs/add" className="btn btn-raised btn-primary waves-effect mb-3 mr-3">
                                                    <i className="zmdi zmdi-plus" style={{ color: '#D7C9A1' }} /> Add
                                                </a>
                                            </div>
                                            <div style={{ position: "relative", maxWidth: "300px" }}>
                                                <input
                                                    type="text"
                                                    placeholder="🔍 Search..."
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        padding: "10px 15px",
                                                        borderRadius: "25px",
                                                        border: "1px solid #ccc",
                                                        outline: "none",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                        fontSize: "14px",
                                                    }}
                                                    className="form-control mb-3"
                                                />
                                            </div>
                                        </div>
                                        <div style={{ maxWidth: "100%", overflowX: "auto" }}>
                                            <DataTable
                                                columns={[
                                                    { name: "ID", selector: (row) => row.id, sortable: true, sortableField: 'id', width: '5%', wrap: true },
                                                    { name: "QUESTION", selector: (row) => trim(row.question), sortable: false, width: '30%', wrap: true },
                                                    { name: "ANSWER", selector: (row) => {
                                                        return <a
                                                            href={ "#" }
                                                            className="btn btn-xs waves-effect waves-float waves-green"
                                                            onClick={() => {
                                                                setSelectedMessage(row);
                                                                setShowModal(true);
                                                            }}
                                                            style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                        >View Answer</a>
                                                    }, sortable: false, width: '30%', wrap: true },
                                                    { 
                                                        name: "STATUS", 
                                                        selector: (row) => (
                                                            <div className="switch">
                                                                <label>
                                                                    <input type="checkbox" name="changestatus" data-userid={row.id} data-status={row.status} checked={row.status === 0} onChange={handleOnChangeEvent} />
                                                                    <span className="lever switch-col-green"></span>
                                                                </label>
                                                            </div>
                                                        ),
                                                        sortable: false,
                                                        width: '10%',
                                                        wrap: true
                                                    },
                                                    { name: "Created At", selector: (row) => convertUTCToLocal(row.created_at, timezone), sortable: true, sortableField: "created_at", width: '15%', wrap: true },
                                                    { 
                                                        name: "ACTIONS", 
                                                        selector: (row) => (
                                                            <div>
                                                                <a
                                                                    href="#"
                                                                    onClick={() => showDeleteConfirmation(row.id)}
                                                                    className="btn btn-xs waves-effect waves-float waves-green mr-1"
                                                                    style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                                >
                                                                    <i className="zmdi zmdi-delete" style={{ color: '#D7C9A1' }} />
                                                                </a>
                                                                <a
                                                                    href={ '/authpanel/faqs/edit/' + btoa(row.id) }
                                                                    className="btn btn-xs waves-effect waves-float waves-green"
                                                                    style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                                >
                                                                    <i className="zmdi zmdi-edit" style={{ color: '#D7C9A1' }} />
                                                                </a>
                                                            </div>
                                                        ),
                                                        sortable: false,
                                                        width: '10%',
                                                        wrap: true
                                                    },
                                                ]}
                                                data={data || []}
                                                defaultSortField="id"
                                                defaultSortAsc={true}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                                paginationPerPage={50} // Default page size
                                                onChangePage={handlePageChange}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onSort={handleSort}
                                                sortServer
                                                persistTableHead
                                                progressPending={loading}
                                                customStyles={customStyles}
                                                noDataComponent={<div style={{ textAlign: "center", padding: "20px", color: "#888" }}>No data found</div>}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <AnswerModal
                timezone={timezone}
                row={selectedMessage}
                isOpen={showModal}
                onClose={() => setShowModal(false)}
            />
        </>
    );
}

const AnswerModal = ({ timezone, row, isOpen, onClose }) => {
    if (!isOpen) return null;
    return (
        <div className="modal-backdrop show" style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 1050,
        }}>
            <div className="modal-content" style={{
                background: "#fff",
                borderRadius: "8px",
                padding: "20px",
                maxWidth: "600px",
                width: "90%",
                maxHeight: "80vh",
                overflowY: "auto",
                position: "relative",
                boxShadow: "0px 5px 15px rgba(0,0,0,0.3)"
            }}>
                <button onClick={onClose} style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    border: "none",
                    background: "transparent",
                    fontSize: "20px",
                    cursor: "pointer"
                }}>&times;</button>
                <h5>Answer details</h5>
                <hr />
                <div className="row">
                    <div className="col-md-12">
                        <div className="about-info-p">
                            <strong>Question</strong> <br />
                            <p className="text-muted">{trim(row.question)}</p>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="about-info-p">
                            <strong>Answer</strong> <br />
                            <p className="text-muted">{trim(row.answer)}</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="about-info-p">
                            <strong>Status</strong> <br />
                            <p className="text-muted">{row.status === 1 ? 'Inactive': 'Active'}</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="about-info-p">
                            <strong>Created At</strong> <br />
                            <p className="text-muted">{convertUTCToLocal(row.created_at, timezone)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};